import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'

const DeleteServiceConfirmation = ({ close, data }) => {
  const { service, onConfirm } = data || {}

  const handleConfirm = () => {
    onConfirm?.()
    close()
  }

  const translations = {
    delete_service: 'Fshi Shërbimin',
    confirm_delete_service: 'A jeni të sigurt që dëshironi të fshini këtë shërbim?',
    this_action_cannot_be_undone: 'Ky veprim nuk mund të kthehet mbrapsht',
    service_to_delete: 'Shërbimi për t\'u fshirë',
    cancel: 'Anulo',
    delete: 'Fshi'
  }

  return (
    <div className={styles.popup_wrapper}>
      <div className={styles.popup_header}>
        <h2>{translations.delete_service}</h2>
      </div>
      <div className={styles.popup_body}>
        <p>
          {translations.confirm_delete_service}
          <span className={styles.warning_text}>
            {translations.this_action_cannot_be_undone}
          </span>
        </p>
        <div className={styles.service_info}>
          <div className={styles.service_label}>{translations.service_to_delete}</div>
          <span className={styles.service_name}>
            {service?.name || service?.operation_name}
          </span>
          {service?.date && (
            <div className={styles.service_date}>
              {new Date(service.date).toLocaleDateString('sq-AL')}
            </div>
          )}
        </div>
      </div>
      <div className={styles.popup_footer}>
        <button onClick={close} className={styles.cancel_button}>
          {translations.cancel}
        </button>
        <button onClick={handleConfirm} className={styles.confirm_button}>
          {translations.delete}
        </button>
      </div>
    </div>
  )
}

DeleteServiceConfirmation.propTypes = {
  close: PropTypes.func.isRequired,
  data: PropTypes.shape({
    service: PropTypes.object,
    onConfirm: PropTypes.func
  })
}

export default DeleteServiceConfirmation 